export var JoyUploadServiceAction;
(function (JoyUploadServiceAction) {
    JoyUploadServiceAction["create"] = "create";
    JoyUploadServiceAction["get"] = "get";
    JoyUploadServiceAction["addMedia"] = "addMedia";
    JoyUploadServiceAction["delete"] = "delete";
})(JoyUploadServiceAction || (JoyUploadServiceAction = {}));
export var JoyUploadServiceUploadType;
(function (JoyUploadServiceUploadType) {
    JoyUploadServiceUploadType["media"] = "media";
    JoyUploadServiceUploadType["voiceNote"] = "voiceNote";
    JoyUploadServiceUploadType["avatar"] = "avatar";
})(JoyUploadServiceUploadType || (JoyUploadServiceUploadType = {}));
export default class JoyUploadService {
    static initialize(provider) {
        JoyUploadService.provider = provider;
    }
    static get instance() {
        return JoyUploadService.provider;
    }
}
JoyUploadService.provider = null;
//# sourceMappingURL=JoyUploadService.js.map